import { captureException } from '@sentry/react';
import { useEffect } from 'react';
import { useNavigate, useRouteError } from 'react-router';
import { Button, Image, Text } from '@/components/base';

/**
 * This component is retrieved from react-router tutorial.
 * https://reactrouter.com/en/main/start/tutorial
 */
const Error = () => {
  // Use any type because useRouteError return unknown type.
  const navigate = useNavigate();
  const error = useRouteError();
  console.error(error);

  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <div
      id="error-page"
      className="flex h-svh w-full flex-col justify-center overflow-auto bg-revamp-cobalt-400 bg-[length:100vw_100vh] bg-fixed bg-center bg-no-repeat text-center"
    >
      <Image src="/assets/images/mascots/mascot-error.png" alt="error" className="mx-auto max-w-[200px]" />
      <Text variant="xl" className="font-semibold text-white">
        {'ขออภัย เกิดข้อผิดพลาดที่ไม่คาดคิด'}
      </Text>
      <Text className="text-white">กรุณาลองใหม่อีกครั้ง</Text>
      <Button variant="solid" color="secondary" className="mx-auto my-16 w-fit px-20" onClick={() => navigate('/')}>
        กลับหน้าหลัก
      </Button>
    </div>
  );
};

export default Error;
